import React, { useState } from 'react';
import './TabsAndContent/Tabs.css';

const EmploymentGapsForm = () => {
    const [activeStep, setActiveStep] = useState(0);

    const steps = [
        {
            title: 'Education to Employment Gap of 3 Years',
            content: 'There is a significant gap between your last education and employment.'
        },
        {
            title: 'Second Step',
            content: 'Description for the second step.'
        },
        {
            title: 'Third Step',
            content: 'Description for the third step.'
        }
    ];

    // const handleNext = () => {
    //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
    // };

    // const handleBack = () => {
    //     setActiveStep((prevActiveStep) => prevActiveStep - 1);
    // };

    return (
        <>
            <div className="py-3" style={{ backgroundColor: "white", padding: 10, border: "1px solid white", }}>
                <div className="initialDetails my-3">
                    <h1 className='tabsContentHead pt-3' style={{ fontSize: "22px", lineHeight: "28px" }}>Company Details</h1>
                    <p className="tabsContentSubHead">There is a significant gap between your last education and employment</p>
                </div>
                <div className="row m-0 p-0">
                    <div className="col-lg-4 col-md-6 col-sm-12 ml-3">
                        <div className="verticalStepper">
                            {steps.map((step, index) => (
                                <div key={index} className={`step ${index === activeStep ? 'active' : ''}`}>
                                    <div className="stepNumber"></div>
                                    {index < steps.length - 1 && <div className="stepLine"></div>}
                                    <div className="stepContent">
                                        <h2 className='stepTitle'>{step.title}</h2>
                                        <p className='stepDescription'>{step.content}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {/* <div className="stepButtons">
                            <button disabled={activeStep === 0} onClick={handleBack}>
                                Back
                            </button>
                            <button disabled={activeStep === steps.length - 1} onClick={handleNext}>
                                Next
                            </button>
                        </div> */}
                    </div>
                    <div className="col-lg-7 col-md-5 col-sm-11 rounded">
                        <textarea className="form-control" id="exampleFormControlTextarea1" style={{ height:"100%"}} placeholder='Enter Reason'></textarea>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EmploymentGapsForm;
